import type { User } from '@api/users';
import { can, CAPABILITIES, type CurrentUser } from '../../lib/capabilities';
import { MANAGEABLE_ROLES } from '../../constants';

/** Mirrors UserPolicy#assign_role?: full managers assign anyone; a team admin
 *  assigns only roles within their own team. */
export function canAssignRole(currentUser: CurrentUser | undefined, role: string): boolean {
  return can(currentUser, CAPABILITIES.USER_ROLES_WRITE)
    || (MANAGEABLE_ROLES[currentUser?.role ?? ''] ?? []).includes(role);
}

/** Hides the write controls only; UserPolicy and the route guard are the boundary. */
export function canEditUser(currentUser: CurrentUser | undefined, target: Pick<User, 'role'>): boolean {
  return can(currentUser, CAPABILITIES.USERS_WRITE) && target.role !== 'system' && canAssignRole(currentUser, target.role);
}
